<template>
  <div class="content">
    <h3>尊敬的用户：</h3>
    <h3 class="t-indent">
      您即将通过本登录页面使用中国移动账户登录上海分互链信息技术有限公司所有的“分互链积分平台”，如果您无法认同如下内容，请您点击“返回”并拒绝授权：
    </h3>
    <p>
      <i>1、</i
      ><span
        >如您点击“继续”，即视为您同意和授权中国移动向上海分互链信息技术有限公司提供账户数据接口以使上海分互链信息技术有限公司可以调用您在中国移动网站（www.10086.cn）的注册账户的登录信息，便于您直接使用您在中国移动网站的注册信息登录“分互链积分平台”。</span
      >
    </p>
    <p>
      <i>2、</i
      ><span
        >如您点击“继续”，即视为您同意及授权上海分互链信息技术有限公司通过数据接口实时读取您在中国移动的消费积分的剩余数量
        。</span
      >
    </p>
    <p>
      <i>3、</i
      ><span
        >如您点击“继续”，则表明您已明确知晓上海分互链信息技术有限公司及“分互链积分平台”并非中国移动的关联公司或由中国移动运营，您使用“分互链积分平台”或上海分互链信息技术有限公司提供的其他服务的行为均与中国移动无关，您也不能就使用中国移动网站注册信息登录及使用“分互链积分平台”的后果要求中国移动承担任何责任。</span
      >
    </p>
    <p>
      <i>4、</i
      ><span
        >上海分互链信息技术有限公司及“分互链积分平台”所提供的商品或服务的质量和品质由上海分互联信息技术有限公司独立负责，上海分互链信息技术有限公司自行对提供该等商品或服务引起的后果向您承担全部责任。</span
      >
    </p>
    <p>
      <i>5、</i
      ><span
        >中国移动郑重提醒您保管好您在中国移动网站的注册登录信息，切勿向任何人透露您的账号、密码等相关信息。除非得到您的同意及授权，中国移动不会向任何第三方透露您的任何信息。</span
      >
    </p>
    <p><i>6、</i><span>中国移动郑重提醒您启用杀毒软件和安全措施，以防范各类网络风险。</span></p>
  </div>
</template>

<script>
export default {
  name: 'cyAuthView',
  components: {},
  data() {
    return {}
  },
  created() {},
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.content {
  padding: 10px;
}
</style>
